import * as React from 'react';
import { sendComponentErrorToSlack } from 'shared/api/callApi';

/** Class definition for detecing project's error. */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    /** Toggle to show fallback ui. */
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    /** Handles rendering or child component errors. */
    componentDidCatch(error, info) {
        sendComponentErrorToSlack(error);
    }

    render() {
        if (this.state.hasError) {
            // Customized and return fallback ui.
            return this.props.fallback;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
